import { Icon } from "@design-system/Icon/Icon";
import { Tag } from "@design-system/Tag/Tag";

import { ValueComponentProps } from "../../../Select";

type Props = ValueComponentProps & {
  onRemove?: (value: string) => void;
  color?: "primary" | "secondary" | "tertiary" | "success" | "warning" | "danger";
  title?: string;
};

export const TagValue = ({
  value,
  options,
  onRemove,
  color = "secondary",
  title,
}: Props) => {
  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering the select dropdown
    onRemove?.(value);
  };

  return (
    <Tag
      text={options.find((o) => o.id === value)?.label}
      title={title}
      maxWidth={256}
      color={color}
      right={
        onRemove && (
          <span
            role="button"
            tabIndex={0}
            onClick={handleRemove}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleRemove(e as unknown as React.MouseEvent);
              }
            }}
            style={{
              background: "none",
              border: "none",
              padding: "0",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              opacity: 0.7,
              marginLeft: "4px",
              outline: "none",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = "1";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = "0.7";
            }}
          >
            <Icon icon="faXmark" size="xs" />
          </span>
        )
      }
    />
  );
};
